import Vue from 'vue'

const search = (pagination) => {
  return Vue.prototype.$http.get('collects', { params: pagination })
}

export default {
  search,
}
